export const ROUTE_PATH = {
  ROOT: '/',
  NOT_FOUND: '/404',
  DOWNLOAD: '/download',
  EXTERNAL_GAMES: '/external-games',
  PREMATCH: '/prematch',
  PREMATCH_SPORTS: '/prematch/sports',
  LIVE: '/live',
  PROMOTIONS: '/promotions',
  RESULTS: '/results',
  PERSONAL: '/personal',
  GIFTS: '/personal/gifts',
  DEPOSIT: '/personal/deposit',
  WITHDRAWAL: '/personal/withdrawal',
  ACTIVE_STAKES: '/personal/active-stakes',
  HISTORY_STAKES: '/personal/history-stakes',
  HISTORY: '/personal/history',
  NOTIFICATIONS: '/personal/notifications',
  CASHBACK: '/personal/cashback',
  SETTINGS: '/personal/profile',
} as const;

export const ROUTE_ALIASES: Record<string, string> = {
  ['games']: 'external-games',
  ['deposits']: 'personal/deposit',
  ['withdrawals']: 'personal/withdrawal',
};
